/**
 * @fileoverview Defines the `KeyProvider` interface and `PROVIDER_API_KEYS` type for managing API keys. Includes a default `EnvKeyProvider` that reads API keys from environment variables.
 */

export interface KeyProvider {
  get(key: string): string | undefined
}

export const PROVIDER_API_KEYS = [
  'ANTHROPIC_API_KEY',
  'OPENAI_API_KEY',
  'BRAINTRUST_API_KEY',
  'VOYAGE_API_KEY',
  'FIREWORKS_API_KEY',
  'GOOGLE_GENERATIVE_AI_API_KEY',
  'GROQ_API_KEY',
  'TURBOPUFFER_API_KEY',
] as const
export type ApiKeys = (typeof PROVIDER_API_KEYS)[number]

export const EnvKeyProvider: KeyProvider = {
  get: (key: string) => process.env[key],
}
